/**
 * Client-side context the analytics backend can't derive from the request alone.
 * Used by the tracking beacons (body fields) and the /out clickout redirect
 * (query params — a top-level GET has no body).
 */

// iPadOS 13+ Safari and its WKWebView report a Mac desktop UA, so server-side UA
// parsing counts iPads as desktops. Touch support is the only client-side tell.
export function deviceHint() {
  return navigator.userAgent.includes('Macintosh') && navigator.maxTouchPoints > 1 ? 'tablet' : undefined
}

// The external referrer of this document, if any. Same-origin (internal SPA nav)
// is stripped so the server buckets it as 'direct'. Sliced to the beacon schema's
// maxLength so an oversized referrer can't fail validation.
export function externalReferrer() {
  const ref = document.referrer
  return ref && !ref.startsWith(window.location.origin) ? ref.slice(0, 2048) : undefined
}
